import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionInitializedAll } from "../redux/ter-actions";
import Spinner from "./Spinner";


const StranaInicijalizacija = (props) => {
  const timeoutRef = useRef(null);
  const dispatch = useDispatch();
  const initialized_0_virtel_schema_optimized = useSelector(state => state.app.initialized_0_virtel_schema_optimized);
  const initialized_1_settings = useSelector(state => state.app.initialized_1_settings);
  const initialized_1_2_lib_ter_const = useSelector(state => state.app.initialized_1_2_lib_ter_const);
  const initialized_1_3_lib_virtel_params = useSelector(state => state.app.initialized_1_3_lib_virtel_params);
  const initialized_1_4_lib_materijal_lim = useSelector(state => state.app.initialized_1_4_lib_materijal_lim);
  const initialized_1_5_lib_cnc_s4_template = useSelector(state => state.app.initialized_1_5_lib_cnc_s4_template);
  const initialized_1_1_users_cache = useSelector(state => state.app.initialized_1_1_users_cache);
  const initialized_1_6_lib_document = useSelector(state => state.app.initialized_1_6_lib_document);
  const initialized_1_7_lib_cparams = useSelector(state => state.app.initialized_1_7_lib_cparams);

  useEffect(() => {
    console.log('StranaInicijalizacija useEffect', initialized_1_settings, initialized_1_3_lib_virtel_params, initialized_1_5_lib_cnc_s4_template, initialized_1_1_users_cache);
    if (initialized_1_settings === true && initialized_1_3_lib_virtel_params === true && initialized_1_4_lib_materijal_lim === true && initialized_1_5_lib_cnc_s4_template === true && initialized_1_1_users_cache === true && initialized_1_6_lib_document === true) {
      // TODO initialized_1_2_lib_ter_const
      // all initalized
      if (timeoutRef.current) {
      } else {
        timeoutRef.current = setTimeout(() => {
          dispatch(actionInitializedAll());
        }, 1000);
      }
    }
    return () => clearTimeout(timeoutRef.current);
  }, [initialized_1_settings, initialized_1_3_lib_virtel_params, initialized_1_5_lib_cnc_s4_template, initialized_1_1_users_cache, initialized_1_6_lib_document]); //

  const _completed_or_not = (is_completed) => {
    if (is_completed) {
      return (<b>ZAVRŠENO</b>);
    } else {
      return (<span>&nbsp;<Spinner inlineSmall /></span>);
    }
  };

  return (
    <>
      <div className="pad">
        <h1>Inicijalizacija...</h1>
        <div>Izvršena inicijalna podešavanja: {_completed_or_not(initialized_1_settings)}</div>
        <div>Optimizovana virtel schema: {_completed_or_not(initialized_0_virtel_schema_optimized)}</div>
        <div>Keširanje liste korisnika: {_completed_or_not(initialized_1_1_users_cache)}</div>
        <div>Keširanje biblioteke Termovent Konstanta: * NOVO...</div>
        <div>Keširanje biblioteke Virtel Params: {_completed_or_not(initialized_1_3_lib_virtel_params)}</div>
        <div>Keširanje biblioteke Materijal Lim: {_completed_or_not(initialized_1_4_lib_materijal_lim)}</div>
        <div>Keširanje biblioteke CNC program S4 templatea: {_completed_or_not(initialized_1_5_lib_cnc_s4_template)}</div>
        <div>Keširanje biblioteke Tabela: {_completed_or_not(initialized_1_6_lib_document)}</div>
        <div>Keširanje biblioteke Cparams: {_completed_or_not(initialized_1_7_lib_cparams)}</div>
        <p><b>Molimo pričekajte...</b></p>
        <Spinner />
      </div>
    </>
  );
};


export default StranaInicijalizacija;